import { useMutation } from "@tanstack/react-query";
import { WiMuleSQL } from "../services/WiMuleSQL";

const updateMachineIDTranslator = async (machineData) => {
  const url = `http://vinterbro.wioss.no/wiMuleAPI/api/MachineFaults/UpdateMachineIDTranslator`;
  console.log("URL:", url); // Confirm URL
  console.log("Machine Data:", JSON.stringify(machineData, null, 2)); // Log data being sent

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "text/plain",
    },
    body: JSON.stringify(machineData),
  });

  if (!response.ok) {
    console.error("Response Status:", response.status); // Log the response status
    throw new Error("Failed to update machine ID translator.");
  }

  return response.json();
};

export const useUpdateMachineIdTranslator = () => {
  return useMutation({
    mutationFn: updateMachineIDTranslator,
    onSuccess: (data) => {
      console.log("Machine ID translator updated successfully:", data);
    },
    onError: (error) => {
      console.error("Error updating machine ID translator:", error.message);
    },
  });
};
